import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatChipsModule } from '@angular/material/chips';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatSnackBarModule } from '@angular/material/snack-bar';

import { AlertsFormComponent } from './alerts-form.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatCardModule,
        MatIconModule,
        MatSelectModule,
        MatChipsModule,
        MatInputModule,
        MatButtonModule,
        MatDatepickerModule,
        MatCheckboxModule,
        MatRadioModule,
        MatSnackBarModule,
    ],
    declarations: [
        AlertsFormComponent
    ],
    exports: [
        AlertsFormComponent,
    ],
    providers: [
        AlertsFormComponent
    ]
})
export class AlertsFormModule {}
